export default __webpack_public_path__ + "static/media/August2009.64043a2e.png";